
import _ from 'lodash';
import { GetterTree } from 'vuex';
import { IPropertyEditState } from '../property-states.store';
import { IPropertyRelationModel } from '../../../../models/property';
import { itemStateConstant } from '../../../../common';

const relationGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{
    service: (state: IPropertyEditState) => state.service,
    listOfRelations: (state: IPropertyEditState): IPropertyRelationModel[] => {
        let list = (state.property.Relations || []).filter(c => c.ItemState != itemStateConstant.Deleted);
        let result = _.orderBy(list, ['RelationTypeId', 'PersonIndex'], ['asc', 'asc']);
        return result;
    },
}

export default relationGetters;